module.exports = __webpack_public_path__ + "img/1f9c0.0304845.svg";